// LoginModal.jsx
import React from 'react';
import Modal from 'react-modal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
  buttonContainer: {
    textAlign: 'center',
  },
  button: {
    width: '15%',
    padding: '10px',
    border: 'none',
    borderRadius: '4px',
    backgroundColor: '#4CAF50',
    color: 'white',
    cursor: 'pointer',
    marginTop: '15px',
  },
};

Modal.setAppElement('#root');

const LoginModal = ({ isOpen, onRequestClose, onLoginClick, cartModal }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel="Login Modal"
    >
      <h2>Please login to add items to your {cartModal ? 'cart' : 'favorites'}.</h2>
      <div style={customStyles.buttonContainer}>
        <button style={customStyles.button} onClick={onLoginClick}>
          Login
        </button>
      </div>
    </Modal>
  );
};

export default LoginModal;
